



































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import store, {
	Stock,
	Livestock as LivestockModel,
	ChartTypes,
	Dataset
} from "../store";
import { mod } from "mathjs";
import { MidpointDates } from "../common/dates";
import DatePicker from "../components/DatePicker.vue";
import Calculations from "./calculations/AllCalculations.vue";
import LivestockCalculations from "../components/calculations/LivestockCalculations.vue"
import ScrollButtons from "../components/ScrollButtons.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { isTestMode, platform, print } from "../mla-shared/";
import BREEDS from "../data/breeds";
import Confirm from "../components/Confirm.vue";
import router from "@/router";
import { detectTouchScreen, debounce } from "../mixins/mixins";
import { colors } from "@/common/colors";
import { getShortBreedName } from "@/common/Formulas/Shared";

const LivestockProps = Vue.extend({
	props: {
		enterprise: {
			type: String
		}
	},
	components: {
		DatePicker,
		ScrollButtons,
		LivestockCalculations
	},
	store
});

@Component
export default class Livestock extends LivestockProps {
	testing: boolean = isTestMode();
	isTouchscreen = detectTouchScreen();
	loading: boolean = false;
	calculations: any = null;
	livestock: LivestockModel = {
		breed: "British (e.g. Angus, Hereford)",
		weight: 0,
		joinOption: true,
		joinNumber: 1,
		joinPeriods: [
			{
				fromDate: store.state.pasture!.simulation.date,
				toDate: store.state.pasture!.simulation.date,
				percentage: 80,
				weanDate: store.state.pasture!.simulation.date,
				expectation: 1
			},
			{
				fromDate: store.state.pasture!.simulation.date,
				toDate: store.state.pasture!.simulation.date,
				percentage: 20,
				weanDate: store.state.pasture!.simulation.date,
				expectation: 1
			}
		]
	};
	stockHeaders = [
		/*{
			text: "Type",
			value: "type",
			align: "start"
		},*/
		{
			text: "Class",
			value: "class",
			align: "start"
		},
		{
			text: "Age (months)",
			value: "startAge",
			align: "center"
		},
		{
			text: "Number",
			value: "startNumber",
			align: "center"
		},
		{
			text: "Weight (kg)",
			value: "startWeight",
			align: "center"
		},
		{
			text: "Purchase date",
			value: "purchaseDate",
			align: "center"
		},
		{
			text: "Age (months)",
			value: "purchaseAge",
			align: "center"
		},
		{
			text: "Number purchased",
			value: "purchaseNumber",
			align: "center"
		},
		{
			text: "Purchase weight (kg)",
			value: "purchaseWeight",
			align: "center"
		},
		{
			text: "Sale date",
			value: "saleDate",
			align: "center"
		},
		{
			text: "Age (months)",
			value: "saleAge",
			align: "center"
		},
		{
			text: "Number sold",
			value: "saleNumber",
			align: "center"
		},
		{
			text: "Target weight (kg)",
			value: "saleWeight",
			align: "center"
		}
	];
	stock: Stock[] = [];
	chartType: ChartTypes = "Bar";
	updateTable:number = 0;
	updateChart: number = 0;
	
	// Return errors array
	get errors() {
		return store.state.errors.livestock || [];
	}

	// Return confirm dialogue reference
	get confirm(): Confirm {
		return this.$refs.confirm as Confirm;
	}

	// Return true when necessary data is available for calculations
	get isReady(): boolean {
		return !!this.livestock && !!this.stock;
	}

	// Return weight lower and upper bounds
	get weightRange() {
		let SRW = BREEDS.parameters["SRW"][getShortBreedName(this.livestock!.breed)]
		return {
			lower: parseInt((SRW * 0.6).toFixed(0)),
			upper: parseInt((SRW * 1.4).toFixed(0))
		}
	}

	// Return weight errors
	get weightErrors() {
		let status = true
		let message = ''
		if ((this.livestock.weight < this.weightRange.lower) || (this.livestock.weight > this.weightRange.upper)) {
			message = 'Weight cannot be outside valid range for breed (' + this.weightRange.lower + '-' + this.weightRange.upper + ').'
		} else {
			status = false
		}
		return {
			status: status,
			message: message
		}
	}

	// Return join percentage errors
	get joinPercentageErrors() {
		let status = true
		let message = ''
		if (
			this.livestock.joinNumber === 2 &&
			((this.livestock.joinPeriods[0].percentage + this.livestock.joinPeriods[1].percentage) > 100)
		) {
			message = 'Joining periods 1 plus 2 must add to no more than 100%.'
		} else if (
			this.livestock.joinNumber === 1 &&
			((this.livestock.joinPeriods[0].percentage < 0) || (this.livestock.joinPeriods[0].percentage > 100))
		) {
			message = 'Join percentage must be between 1% and 100%.'
		} else {
			status = false
		}
		return {
			status: status,
			message: message
		}
	}

	// Return join dates errors
	get joinDatesErrors() {
		let status = true
		let message = ''
		let jp1DatesStatus = (
			this.livestock.joinPeriods[0].fromDate ===
			this.livestock.joinPeriods[0].toDate
		)
		let jp2DatesStatus = (
			this.livestock.joinPeriods[1].fromDate ===
			this.livestock.joinPeriods[1].toDate
		)
		if (
			(this.livestock.joinNumber === 1 && jp1DatesStatus) ||
			(this.livestock.joinNumber === 2 && (jp1DatesStatus || jp2DatesStatus))
		) {
			message = 'Joining period FROM and TO dates cannot be the same.'
		} else {
			status = false
		}
		return {
			status: status,
			message: message
		}
	}

	// Return join expectation error
	get joinExpectationErrors() {
		let status: boolean[] = [false, false]
		let message = ''
		if (((this.livestock.joinPeriods[0].expectation <= 0) || (this.livestock.joinPeriods[0].expectation > 2))) {
			status[0] = true
			message = 'Enter a decimal fraction between 0.01 and 2.'
		}
		if ((this.livestock.joinPeriods[1].expectation <= 0) || (this.livestock.joinPeriods[1].expectation > 2)) {
			status[1] = true
			message = 'Enter a decimal fraction between 0.01 and 2.'
		}
		return {
			status: status,
			message: message
		}
	}

	// Return join period status
	get joinPeriodCompleted(): boolean {
		return (
			!this.weightErrors.status &&
			!this.joinPercentageErrors.status &&
			!this.joinDatesErrors.status &&
			!this.joinExpectationErrors.status[0] &&
			!this.joinExpectationErrors.status[1]
		)
	}

	// Return array of breeds
	get breeds() {
		return this.enterprise === "cattle" ? BREEDS.cattle : BREEDS.sheep;
	}

	// Return calculations component reference
	get calcRef(): Calculations {
		return this.$refs.livestockCalcs as Calculations;
	}

	// Return chart data if calculations available
	get chartData() {
		// console.log('this.calculations', this.calculations)
		if (this.calculations) {
			// Datasets (classes, weaned and unweaned)

			// OPTION 1
			/*let datasets: Dataset[] = this.calcRef
				.headOfStock()
				.datasets.concat(this.calcRef.weanedData().datasets);
			// Labels - Midpoints since start date
			let labels: string[] = [];
			let periods: number[] = this.calcRef.periods;
			MidpointDates.forEach((mpd: any, ix: number) => {
				labels.push(MidpointDates[mod(periods[ix] - 1, 24)]);
			});*/

			// OPTION 2
			let datasets: Dataset[] = this.calculations.headOfStock.datasets.concat(this.calculations.weanedData.datasets)
			let labels: string[] = [];
			let periods: number[] = this.calculations.periods;
			MidpointDates.forEach((mpd: any, ix: number) => {
				labels.push(MidpointDates[mod(periods[ix] - 1, 24)]);
			});
			datasets.map(ds => {
				let weanedLabel: string = (this.enterprise === "cattle" ? "Calves" : "Lambs") + " weaned this year";
				if (ds.label === weanedLabel) {
					ds.backgroundColor = colors[this.enterprise][weanedLabel];
				}
			})

			// Clear datasets if stock is empty
			let hasStock: number = 0
			this.stock.map(s => { hasStock += ((s.startNumber || 0) + s.purchaseNumber) })

			return {
				labels: labels,
				datasets: hasStock ? datasets : []
			};
		} else {
			return {};
		}
	}

	// Return chart options prop
	get chartOptions() {
		return {
			responsive: true,
			maintainAspectRatio: true,
			showAllTooltips: true,
      aspectRatio: this.$vuetify.breakpoint.width < 768 ? 1.5 : 3,
      resizeDelay: 1000,
      interaction: {
        mode: 'index',
        intersect: false,
      },
			scales: {
				x: {
					display: this.chartType !== "Radar",
					position: "bottom",
					stacked: true,
					title: {
						display: true,
						text: "Month",
						color: "#000",
						font: {
							size: 14
						},
						padding: {
							top: 15
						}
					},
					ticks: {
						color: "#000"
					},
					grid: {
						color: "rgba(0,0,0,0.05)",
						tickColor: "#000",
						borderColor: "#000"
					}
				},
				y: {
					display: this.chartType !== "Radar",
					position: "left",
					stacked: true,
					grace: '5%',
					title: {
						display: true,
						text: "Head of Stock",
						color: "#000",
						font: {
							size: 14
						},
						padding: {
							bottom: 15
						}
					},
					ticks: {
						color: "#000"
					},
					grid: {
						color: "rgba(0,0,0,0.05)",
						tickColor: "#000",
						borderColor: "#000"
					}
				}
			},
			plugins: {
				chartAreaBorder: {
					borderColor: "rgba(0,0,0,0.1)",
					borderWidth: 1
				},
				tooltip: {
					filter: function(tooltipItem: any) {
						return tooltipItem.dataset.pointStyle != "triangle" && tooltipItem.raw > 0;
					},
					callbacks: {
						label: function(context: any) {
							let yLabel: string = "";
							if (context.raw !== null) {
								yLabel += Math.round(context.raw);
							}
              if (context.raw > 0) {
                return (
                  context.dataset.label +
                  ": " +
                  yLabel
                );
              }
						},
						labelColor: function(context: any) {
							let dataset =
								context.chart.config.data.datasets[
									context.datasetIndex
								];
							return {
								borderColor:
									dataset.backgroundColor != "transparent"
										? dataset.backgroundColor
										: dataset.borderColor,
								backgroundColor:
									dataset.backgroundColor != "transparent"
										? dataset.backgroundColor
										: dataset.borderColor
							};
						},
						footer: (tooltipItems:any) => {
							let total:number = 0;
							tooltipItems.map((a:any) => { total += a.raw });
							return 'Total stock: ' + Math.round(total);
						}
					}
				},
				legend: {
					display: true,
					position: 'top',
          // align: 'start',
					labels: {
						usePointStyle: true,
						boxWidth: 12,
						color: "#000",
						font: {
							size: 16
						},
						filter: function(legendItem: any, chart:any) {
							let sum:number = 0
							if (chart.datasets[legendItem.datasetIndex].data.length > 0) {
								sum = chart.datasets[legendItem.datasetIndex].data.reduce((a:number, b:number) => a + b)
							}
							if (!legendItem.text.includes("ignore") && sum > 0) {
							  return legendItem.text;
              }
						},
						generateLabels: function(chart: any) {
							var data = chart.data;
							var legends = Array.isArray(data.datasets)
								? data.datasets.map(function(
										dataset: any,
										i: number
								  ) {
                    return {
                      text: dataset.label,
                      datasetIndex: i,
                      fillStyle: dataset.borderDash
                        ? "transparent"
                        : dataset.backgroundColor,
                      hidden: !chart.isDatasetVisible(i),
                      pointStyle: "rect",
                      borderRadius: 0
                    };
								  },
								  this)
								: [];
							return legends;
						}
					}
				}
			}
		};
	}

	// Populate stock on component create if it does not exist
	created() {
		if (!this.isReady) {
			return;
		}
		if (
			this.enterprise === "cattle" &&
			store.state.cattle !== null &&
			store.state.cattle.livestock !== null &&
			store.state.cattle.stock !== null
		) {
			this.livestock = store.state.cattle.livestock;
			this.stock = store.state.cattle.stock;
		} else if (
			this.enterprise === "sheep" &&
			store.state.sheep !== null &&
			store.state.sheep.livestock !== null &&
			store.state.sheep.stock !== null
		) {
			this.livestock = store.state.sheep.livestock;
			this.stock = store.state.sheep.stock;
		} else {
			this.getDefaults();
		}
		this.updateChart += 1;
	}


	// Update state on component destroy
	/* beforeDestroy() {
		this.updateState();
	} */

	// Watch for updates and update state and calculations accordingly
	@Watch("updateChart")
	onUpdate(this: any, val: any, oldVal: any) {
		this.updateState();
	}

	// Debounce update on value change
	debounceUpdate(duration?:number) {
		// this.loading = true;
		let d = duration || 1000;
		debounce('updated', async () => {
			// this.loading = false;
			this.updateChart += 1;
			// console.log('debounce: ' + d + 'ms')
		}, d)
	}

	// Update enterprise stored state on change
	updateState() {
		this.calculations = store.getters.calculations[this.enterprise];
		if (this.enterprise === "cattle") {
			store.dispatch("updateCattle", this.$data);
		} else if (this.enterprise === "sheep") {
			store.dispatch("updateSheep", this.$data);
		}
	}

	// Get default livestock options
	getDefaults() {
		// Get default livestock
		this.livestock!.breed = this.breeds.names[0];
		this.livestock!.weight = this.enterprise === "cattle" ? 500 : 65;

		// Get default stock
		let stock: any[] = [];
		for (let i = 0; i < this.breeds.classes.breeding.length; i++) {
			stock.push({
				type: "Breeding",
				class: this.breeds.classes.breeding[i]
			});
		}
		for (let i = 0; i < 10; i++) {
			stock.push({
				type: "Trading",
				class: this.breeds.classes.trading[0]
			});
		}

		stock.forEach((s: any, index: number) => {
			s.startAge = 0;
			s.startNumber = 0;
			s.startWeight = 0;
			s.purchaseDate = this.$store.state.pasture.simulation.date;
			s.purchaseAge = 0;
			s.purchaseNumber = 0;
			s.purchaseWeight = 0;
			s.saleDate = this.$store.state.pasture.simulation.date;
			s.saleAge = 0;
			s.saleNumber = 0;
			s.saleWeight = 0;
		});

		this.stock = stock;
		this.updateTable += 1;
		this.updateChart += 1;
	}

	// Date change event
	// section  = join periods or stock
	// newDate  = new date
	// property = join period date property
	// index    = join period number
	dateChange(section: string, newDate: any, property: string, index: number) {
		if (section === "joinPeriods") {
			switch (property) {
				case "fromDate":
					this.$set(
						this.livestock!.joinPeriods[index],
						"fromDate",
						newDate
					);
					break;
				case "toDate":
					this.$set(
						this.livestock!.joinPeriods[index],
						"toDate",
						newDate
					);
					break;
				case "weanDate":
					this.$set(
						this.livestock!.joinPeriods[index],
						"weanDate",
						newDate
					);
					break;
			}
		}
		if (section === "stockTable") {
			switch (property) {
				case "purchaseDate":
					this.$set(this.stock![index], "purchaseDate", newDate);
					break;
				case "saleDate":
					this.$set(this.stock![index], "saleDate", newDate);
					break;
			}
		}
		this.debounceUpdate();
	}

	// Wean check: return true if 'Weaned this year'
	weanCheck(arg: string): boolean {
		return arg.toLowerCase().includes("weaned this year");
	}

	// Mature check: return true if class is mature
	matureCheck(arg: string): boolean {
		return (
			arg.toLowerCase().startsWith("cows") ||
			arg.toLowerCase().includes("ewes (>2 years)")
		);
	}

	// Print page
	async print() {
		if (platform() == "web") {
			await print();
		} else {
			const scanvas: HTMLCanvasElement | null = document.getElementById(
				"stock"
			) as HTMLCanvasElement;
			if (scanvas && scanvas.parentElement) {
				const img = document.createElement("img");
				if (img) {
					img.src = scanvas.toDataURL();
					img.style.width = `${scanvas.clientWidth}px`;
					img.style.height = `${scanvas.clientHeight}px`;
					scanvas.parentElement.insertBefore(
						img,
						scanvas.nextSibling
					);
					const previousDisplay = scanvas.style.display;
					scanvas.style.display = "none";

					await print();

					if (scanvas && img.parentElement) {
						img.parentElement.removeChild(img);
						scanvas.style.display = previousDisplay;
					}
				} else {
					await print();
				}
			} else {
				await print();
			}
		}
	}

	// Clear stock inventory / reset to default
	async clearInventory(this: any) {
		if (
			await this.confirm.open(
				"Clear Inventory",
				"Are you sure you want to clear the current inventory? This will also reset the selected breed and weight.",
				{
					color: "red",
					width: 400,
					cta: "Clear"
				}
			)
		) {
			this.getDefaults();
		}
	}

	// Validation
	async validate() {
		let valid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
		let title: string = "";
		let message: string = "";
		let status: boolean = false;

		// Missing required data
		if (this.errors && this.errors.length > 0) {
			title = "Invalid fields:";
			status = false;
			message = this.errors.join(", ");
		// Invalid data
		} else if (!valid) {
			title = 'Invalid data'
			status = false
			message = 'Please correct the invalid data highlighted in red.'
		// Invalid weight
		} else if (this.weightErrors.status) {
			title = 'Invalid weight'
			status = false
			message = 'Please input a valid weight for the selected breed (' + this.weightRange.lower + '-' + this.weightRange.upper + ').'
		// Invalid join percentage
		} else if (this.joinPercentageErrors.status) {
			title = 'Invalid join percentage'
			status = false
			message = 'Please input a valid join percentage.'
		// Invalid join expectation
		} else if (this.joinExpectationErrors.status[0] || this.joinExpectationErrors.status[1]) {
			title = 'Invalid join expectation'
			status = false
			message = 'Please input a valid join expectation between 0.01 and 2.'
		// Joining from and to dates must be different
		} else if (
			(this.livestock!.joinNumber <= 2 &&
				this.livestock!.joinPeriods[0].fromDate ===
					this.livestock!.joinPeriods[0].toDate) ||
			(this.livestock!.joinNumber === 2 &&
				this.livestock!.joinPeriods[1].fromDate ===
					this.livestock!.joinPeriods[1].toDate)
		) {
			title = "Invalid join period dates";
			message = "Joining period FROM and TO dates cannot be the same.";
			status = false;
		// At least one instance of stock data must be entered
		} else if (
			store.state[this.enterprise].stock.filter(
				(s: Stock) => (s.startNumber && (s.startNumber > 0)) || s.purchaseNumber > 0
			).length <= 0
		) {
			title = "Empty Inventory";
			message = "Please enter values into the inventory.";
			status = false;
		} else {
			status = true;
		}

		// If no errors continue to destination route
		if (status === true) {
			let name = "Demand";
			if (
				this.$store.state.pasture.simulation.enterprise ===
				"Cattle & Sheep"
			) {
				if (this.enterprise === "cattle") {
					name = "Sheep";
				}
			}
			router.push({ name: name });
		} else {
			await this.confirm.open(
				title.length > 0 ? title : "Error",
				message,
				{
					color: "red",
					cta: "Okay"
				}
			);
		}
	}
}
